export default "__VITE_PUBLIC_ASSET__9206a4da__"